module.exports = __webpack_public_path__ + "static/img/u70067.a0edc076.png";